import { render, staticRenderFns } from "./introduceDetails.vue?vue&type=template&id=5ffb92ff&"
import script from "./introduceDetails.vue?vue&type=script&lang=js&"
export * from "./introduceDetails.vue?vue&type=script&lang=js&"
import style0 from "./introduceDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports